import { Industry } from '../Model/Industry';
import { JobCenterModelInterface } from '../Model/JobCenterModelInterface';
import { GroupContainer } from './GroupContainer';

function reduce<T, R>(
    collection: T[],
    callback: (previousValue: R, currentValue: T, currentIndex: number, array: T[]) => R,
    initialValue: R
): R {
    return Array.prototype.reduce.call(collection, callback as any, initialValue) as any;
}

const fallbackIndustry = new Industry('Generell', '' + (+new Date()));

type GroupResult<K> = { header: K, key: string } | undefined;

/**
 * Service to group Job Center filteredModels
 */
export class GroupBuilder {
    /**
     * Group the given collection by the key returned by `collector`
     *
     * The `collector` must return a string defining the name of the Group
     * or `undefined` if the item should not be added to any Group
     *
     * @param {T[]} collection
     * @param {(model: T) => (string | undefined)} collector
     * @return {GroupContainer<T>}
     */
    public groupBy<K, T extends JobCenterModelInterface>(
        collection: T[],
        collector: (model: T) => GroupResult<K>
    ): GroupContainer<K, T> {
        return reduce(
            collection,
            (container: GroupContainer<K, T>, model: T) => {
                const result = collector(model);
                if (result !== undefined) {
                    container.add(result.header, model, result.key);
                }

                return container;
            },
            new GroupContainer()
        );
    }

    public groupByIndustry<T extends JobCenterModelInterface>(collection: T[]): GroupContainer<Industry, T> {
        return this.groupBy(collection, (model) => {
            const industry = model.industry;

            if (industry) {
                return {header: industry, key: industry.referenceId};
            } else {
                return {header: fallbackIndustry, key: fallbackIndustry.referenceId};
            }
        });
    }
}
